function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { defaultGiveawayVariant } from '../reducers/giveaway-color-and-size-variants.reducer';
function getNextColors({
  prevColors,
  color
}) {
  let isRemoved = false;
  const result = prevColors.filter(item => {
    if (item === color) {
      isRemoved = true;
      return false;
    }
    return true;
  });
  if (!isRemoved) {
    result.push(color);
  }
  return result;
}
export function getNextProductSelections({
  giveawayColorAndSizeVariantsState,
  giveawaySelectedItemsState
}, {
  productId,
  color,
  isOneProduct
}) {
  const variant = giveawayColorAndSizeVariantsState[productId] || {};
  const isProductWithColorAlready = variant.colors.some(item => item === color);
  const nextColorsForOneProduct = isProductWithColorAlready ? [] : [color];
  const nextColors = isOneProduct ? nextColorsForOneProduct : getNextColors({
    color,
    prevColors: variant.colors || []
  });
  const nextColorAndSize = _objectSpread({}, defaultGiveawayVariant, variant, {
    colors: nextColors
  });
  let nextGiveawaySelectedItemsState = giveawaySelectedItemsState;
  if (nextColorAndSize.colors.length === 0 && !nextColorAndSize.size) {
    nextGiveawaySelectedItemsState = giveawaySelectedItemsState.filter(id => id !== productId);
  }
  return {
    giveawayColorAndSizeVariantsState: _objectSpread({}, giveawayColorAndSizeVariantsState, {
      [productId]: nextColorAndSize
    }),
    giveawaySelectedItemsState: nextGiveawaySelectedItemsState
  };
}